import React, { Component } from 'react';
import {Divider, Header, Segment, Button, Message} from 'semantic-ui-react';
import { Formik, Form, Field } from 'formik';
import ReCAPTCHA from "react-google-recaptcha";
import FormsInputsText from '../../inputs/text/forms_inputs_text';
import RegisterIdentitySchema from './validate';

class FormsRegisterIdentity extends Component {

    state = {
        error: false,
        errorMessage: null,
        success: false,
        errorTitle: '',
        robot_token: ''
    }

    renderFormSubmissionResult() {
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there is an issue</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }

    render() {
        const {updateStepIndex} = this.props;
        return (
            <Formik
                initialValues={{
                    nric: ''
                }}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={RegisterIdentitySchema}
                onSubmit={(values, actions) => {
                    var response = window.grecaptcha.getResponse();
                    console.log("response ", response)
                    // console.log(values, actions);
                    this.setState({error: false, errorMessage: null});
                    if(response == ''){
                        actions.setSubmitting(false);
                        this.setState({error: true, errorTitle: "Invalid Captcha", errorMessage: "Please verify your captcha"});
                    }else{
                        this.props.registerVerifyIdentity({nric: values.nric, robot_token: response}, (result, error) => {
                            if (error) {
                                this.setState({error: true, errorMessage: error.errorMessage, robot_token: ''});
                                window.grecaptcha.reset();
                                actions.setSubmitting(false);
                            }
                            if (result) {
                                window.grecaptcha.reset();
                                console.log("check user in register verify identity", result.user);
                                const {name, contactNo, contactNoCountryCode, email, requireRegistrationEmail, emailEditable, OTPtype} = result.user;
                                this.setState({robot_token: ''});
                                updateStepIndex(2, {
                                    identifier: values.nric,
                                    name,
                                    contactNo,
                                    contactNoCountryCode,
                                    email,
                                    requireRegistrationEmail,
                                    emailEditable,
                                    hasVerifiedIdentity: true,
                                    OTPtype
                                });
                            }
                        });
                    }
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Segment>
                        <Form>
                            <Header as='h2'>
                                Identification
                            </Header>
                            <Divider />
                            <Message warning>
                                <Message.Header>
                                    Hi, welcome to GroupCare@Income!
                                </Message.Header>
                                <p>
                                    To begin, please enter your NRIC / FIN / Passport No below
                                </p>
                            </Message>
                            <Field name="nric" label="" component={FormsInputsText} 
                                secondaryLabel="NRIC / FIN / Passport No."
                            />
                            &nbsp;
                            <ReCAPTCHA 
                                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                onChange={(value) => {
                                    if(value){
                                        this.setState({
                                            robot_token: value
                                        })
                                    }
                                }}
                            />
                            &nbsp;
                            <Button 
                                type="submit" 
                                primary 
                                disabled={isSubmitting} 
                                fluid 
                                loading={isSubmitting}
                            >
                                Verify Identity
                            </Button>
                            <p>
                                &nbsp;
                            </p>
                            {
                                this.renderFormSubmissionResult()
                            }
                        </Form>
                    </Segment>
                )}
            />
        );
    }

}

export default FormsRegisterIdentity;